/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CloneEditVideoEditorEditsMutationRequest, CloneEditVideoEditorEditsMutationResponse, CloneEditVideoEditorEditsPathParams } from "../models/CloneEditVideoEditorEdits";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { cloneEditVideoEditorEdits } from "../axios/cloneEditVideoEditorEdits";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const cloneEditVideoEditorEditsMutationKey = () => ["web-app-bff-api", { url: '/video-editor/edits/:id/clone' }] as const

export type CloneEditVideoEditorEditsMutationKey = ReturnType<typeof cloneEditVideoEditorEditsMutationKey>

export function cloneEditVideoEditorEditsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CloneEditVideoEditorEditsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = cloneEditVideoEditorEditsMutationKey()
        return mutationOptions<CloneEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, {id: CloneEditVideoEditorEditsPathParams["id"], data: CloneEditVideoEditorEditsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return cloneEditVideoEditorEdits(id, data, config)
          },
        })

}

/**
 * @summary Clone an edit (requires new name); response includes creator and published platforms
 * {@link /video-editor/edits/:id/clone}
 */
export function useCloneEditVideoEditorEdits<TContext>(options: 
{
  mutation?: UseMutationOptions<CloneEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, {id: CloneEditVideoEditorEditsPathParams["id"], data: CloneEditVideoEditorEditsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CloneEditVideoEditorEditsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? cloneEditVideoEditorEditsMutationKey()

          const baseOptions = cloneEditVideoEditorEditsMutationOptions(config) as UseMutationOptions<CloneEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, {id: CloneEditVideoEditorEditsPathParams["id"], data: CloneEditVideoEditorEditsMutationRequest}, TContext>
          

          return useMutation<CloneEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, {id: CloneEditVideoEditorEditsPathParams["id"], data: CloneEditVideoEditorEditsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CloneEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, {id: CloneEditVideoEditorEditsPathParams["id"], data: CloneEditVideoEditorEditsMutationRequest}, TContext>
      
}